import { Injectable, inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable, map } from 'rxjs';
import { StubAccessService } from '../access';
import { Views } from '../access/interface';

@Injectable({ providedIn: 'root' })
export class AccessPartnerAdminViewGuard {
  private readonly accessService = inject(StubAccessService);
  private readonly router = inject(Router);

  canActivate(): Observable<boolean | UrlTree> {
    return this.accessService.hasAccessToViews([Views.partnerAll]).pipe(
      map((hasAccess) => {
        if (hasAccess[0]) {
          return true;
        }
        return this.router.createUrlTree(['/access-denied']);
      }),
    );
  }
}
